(ns common.schema.entities.transaction-process.core
  (:require [common.schema.entities.transaction-process :as transaction-process]
            [common.transaction-process.access :as tp-access]))

;; Unlike the other recently-ported entities, transaction-process's real
;; read-permission check (common.transaction-process.access/can-access-transaction-process?)
;; already lives in its own standalone namespace with no dependency on
;; entity_types.cljc or the entity-type-registry - it can be required and
;; reused directly here, no verbatim-copy-to-avoid-a-cycle needed. It's also
;; a genuinely row-level check (depends on the specific entity's
;; :transaction-process/team-assignments-edn, not just a flat module/plan
;; check), which the dedicated-index permissions-fn-maker
;; (backend.domain.entities.transaction-process.permissions) has to
;; replicate at the per-document level - see that namespace for how.
(defn- disable-permissions-check-fn
  [{:keys [tr] :as ctx}]
  (when-not (tp-access/can-access-transaction-process? ctx)
    (tr :not-allowed)))

(def entity-type-definition
  {:entity-type                  :entity.type/transaction-process
   :schema                       transaction-process/schema
   :name                         {:en "Transaction process"}
   :plural                       {:en "Transactions"}
   :icon                         :fa-exchange-alt
   :create-icon                  :fa-exchange-alt
   :read-permissions-check-fn    tp-access/can-access-transaction-process?
   :disable-permissions-check-fn disable-permissions-check-fn
   ;; No pre-existing legacy dedicated OpenSearch index at all for this
   ;; entity type (not even a stub :change-listening?/:select-searchable?
   ;; entry) - :search-index? left unset/true so the generic materialization
   ;; pipeline creates a genuinely new dedicated index via
   ;; backend.search.dedicated.indexes/ensure-index-up-to-date!, same as
   ;; sale-agreement/contract-kyc-profile/counterparty-diligence (see
   ;; ai/mistakes.md). :entity.type/transaction-process is not in
   ;; common.permissions.entity-permissions/CONFIGURABLE_ENTITIES, so none of
   ;; these default columns are at risk of being tenant-disabled the way
   ;; fund-commitment's/investor's were - confirmed every field below has a
   ;; static :default-field-visibility :in-use.
   :search                       {:result/title-attr    :transaction-process/short-name
                                  :list/default-columns [:transaction-process/short-name
                                                         :transaction-process/vehicle
                                                         :transaction-process/stage
                                                         :transaction-process/status
                                                         :common/created-on
                                                         :transaction-process/anticipated-decision-date]
                                  :views {:grid {:po-default-field-paths [[:transaction-process/short-name]
                                                                          [:transaction-process/vehicle]
                                                                          [:transaction-process/stage]
                                                                          [:transaction-process/status]
                                                                          [:common/created-on]
                                                                          [:transaction-process/anticipated-decision-date]]
                                                 :mandatory-field-paths [[:transaction-process/short-name]]}}}})
